import React, { useEffect, useRef, useState } from "react";
import "./Navbar.scss"
import { useDispatch, useSelector } from "react-redux";
import menu from "../../assets/menunew.svg"
import config from "react-global-configuration";
import search from "../../assets/search.svg"
import cart from "../../assets/cart.svg"
import notification from "../../assets/notification.svg"
import user from "../../assets/user.svg"
import close from "../../assets/close.svg"
import _ from "lodash";
import { getAllData } from "../../../../../../../redux/resturantWidgetSlice";
import { setIsCartOpen, setSelectedOffer } from "../../../../../../../redux/companyDataSlice";
import IMAGE_PLACEHOLDER from "../../assets/images/Images/empty-placeholder.png"
import { useHistory } from "react-router";
import clock from "../../assets/calendar.svg"
import loc from "../../assets/location-black.svg"
import arrow from "../../assets/arrow-black.svg"
import moment from 'moment';

const Navbar = ({ setIsLeftDrawerOpen, setAddDeliveryLoc, setIsStoreClosed }) => {
    const company = useSelector((state) => state.companyData.company);
    const restaurantDataState = useSelector((state) => state.resturantData);
    const { selectedOrderType } = useSelector((state) => state.resturantData);
    const userDetails = localStorage.getItem('DELIVERY_DATA')
    let parsedUserDetails = JSON.parse(localStorage.getItem('DELIVERY_DATA'))
    const addressDelivery = userDetails ? parsedUserDetails.Addresses.find((address) => address.AddressType === "Delivery") : null

    const [searchKey, setSearchKey] = useState('')
    const [items, setItems] = useState([])
    const [data, setData] = useState(null)
    const dispatch = useDispatch()
    const history = useHistory()
    const containerRef = useRef(null);
    const getFormatSchedule = () => {
        const iso = JSON.parse(localStorage.getItem("schedule_order"))?.StartTime;
        const isoend = JSON.parse(localStorage.getItem("schedule_order"))?.EndTime;
        if (!iso && !isoend) return "";

        const date = moment.utc(iso);
        const dateEnd = moment.utc(isoend);
        const today = moment();
        const isToday = date.isSame(today, 'day');
        const isTomorrow = date.isSame(today.clone().add(1, 'day'), 'day');

        if (isToday) return {
            date: "Today",
            time: date.format('hh:mm A') + "-" + dateEnd.format('hh:mm A')
        };;
        if (isTomorrow) return {
            date: "Tomorrow",
            time: date.format('hh:mm A') + "-" + dateEnd.format('hh:mm A')
        };;

        return {
            date: date.format(' ddd, DD MMM'),
            time: date.format('hh:mm A') + "-" + dateEnd.format('hh:mm A')
        };
    }
    useEffect(() => {
        fetchDBData()
    }, []);
    const fetchDBData = async () => {
        await getAllData().then((result) => {
            setData(result?.data);
            if (result?.data && result?.data?.Categories && result?.data?.Categories?.length > 0) {
                let array = result?.data.Categories.map((val) => {
                    return val.MenuEntities.map((menuEntity) => {
                        const menuItem = _.find(result?.data.Items, { MenuItemID: menuEntity.ID });
                        return { ...menuItem, Category: val.Title.en };
                    });
                }).flat();

                setItems(array)
            }
        });
    }
    useEffect(() => {
        if (data && data?.Categories && data?.Categories?.length > 0) {
            let array = data.Categories.map((val) => {
                return val.MenuEntities.map((menuEntity) => {
                    const menuItem = _.find(data.Items, { MenuItemID: menuEntity.ID });
                    return { ...menuItem, Category: val.Title.en };
                });
            }).flat();

            setItems(array)
        }
    }, [searchKey])
    const searchedItems = (searchingValue) => {
        return items.filter(item => item.Title && item.Title.en && item.Title.en.toLowerCase().includes(searchingValue.toLowerCase()));
    }
    return (
        <div className="MenuNavbarV4">
            <div className="MenuNavbarV4-inner"
                style={{ backgroundColor: company?.Style?.NavigationColor }}>
                <div className="MenuNavbarV4-inner-left">
                    <img className="MenuNavbarV4-inner-left-menu"
                        onClick={() => {
                            setIsLeftDrawerOpen(true)
                        }} alt="" src={menu} />
                    <img
                        className="MenuNavbarV4-inner-left-logo"
                        style={{ maxHeight: "48px" }}
                        src={config.get("companyLogo")}
                        draggable="false"
                    />
                    {selectedOrderType === "" || (window.location.pathname.includes("/order") || window.location.pathname.includes("/account")) ? "" : selectedOrderType !== "table" &&
                        <div className='MenuNavbarV4-inner-left-cont'
                            style={{ backgroundColor: (selectedOrderType === "delivery" && addressDelivery?.City) || localStorage.getItem("schedule_order") ? "" : "transparent" }}>

                            {selectedOrderType === "delivery" && addressDelivery?.City &&
                                <div className='MenuNavbarV4-inner-left-cont-item'
                                    onClick={() => {
                                        setAddDeliveryLoc(true)
                                    }}>
                                    <img alt='' src={loc} className='MenuNavbarV4-inner-left-cont-item-img' />
                                    <div className='MenuNavbarV4-inner-left-cont-item-text'>
                                        <div className='MenuNavbarV4-inner-left-cont-item-text-hdr'>Delivering to</div>
                                        <div className='MenuNavbarV4-inner-left-cont-item-text-sub'>{addressDelivery?.City}, UK</div>
                                    </div></div>}
                            {(selectedOrderType === "delivery" && addressDelivery?.City) && localStorage.getItem("schedule_order") &&
                                <div className="MenuNavbarV4-inner-left-cont-sep" />}

                            {localStorage.getItem("schedule_order") ?
                                <div className='MenuNavbarV4-inner-left-cont-item'
                                    onClick={() => {
                                        setIsStoreClosed(true)
                                    }}>
                                    <img alt='' src={clock} className='MenuNavbarV4-inner-left-cont-item-img' />
                                    <div className='MenuNavbarV4-inner-left-cont-item-text'>
                                        <div className='MenuNavbarV4-inner-left-cont-item-text-hdr'>{getFormatSchedule().date}</div>
                                        <div className='MenuNavbarV4-inner-left-cont-item-text-sub'>{getFormatSchedule().time}</div>
                                    </div>
                                    <img alt="" src={arrow} className='MenuNavbarV4-inner-left-cont-item-img2' />
                                </div> : ""}
                        </div>}
                </div>
                <div className="MenuNavbarV4-inner-right">
                    <div className="MenuNavbarV4-inner-right-search" ref={containerRef} >
                        <div className="MenuNavbarV4-inner-right-search-inner">
                            <img alt="" src={search} />
                            <input className='MenuNavbarV4-inner-right-search-inner-input'
                                placeholder='Search for dishes, restaurants...'
                                value={searchKey} onChange={e => {
                                    setSearchKey(e.target.value)
                                }} />
                            {searchKey !== "" && < img alt='' src={close}
                                className='close-image' onClick={() => { setSearchKey("") }} />}
                        </div>
                        {searchKey !== "" &&
                            <div className='searched-container'>
                                {searchedItems(searchKey).length > 0 ? searchedItems(searchKey).map((value, index) => {
                                    return (
                                        <div key={index} className='searched-item-cont' onClick={() => {
                                            localStorage.removeItem("OFF_QT")
                                            localStorage.removeItem("MODQUANTITY")
                                            localStorage.removeItem("ECOM_OFF_SL")
                                            dispatch(setSelectedOffer(value.MenuItemID + "/new"))
                                            setSearchKey("")
                                        }}>
                                            <img style={{ objectFit: !value.ImageURL ? "fill" : "" }} alt='' className='searched-image-cont' src={value.ImageURL ? value.ImageURL : IMAGE_PLACEHOLDER} />
                                            <div className='items-cont'>
                                                <div className='searched-title'>
                                                    {value.Title.en}</div>
                                                <div className='searched-cat'>{value.Category}</div></div></div>
                                    )
                                }) : <div className='empty-search'>No results found for <b>{searchKey}</b></div>}</div>}
                    </div>
                    <div className="MenuNavbarV4-inner-right-icon">
                        <div className="MenuNavbarV4-inner-right-icon-ic-search"
                            onClick={() => {
                                history.push("/item/search")
                            }} >
                            <img alt="" src={search} />
                        </div>
                        <div className="MenuNavbarV4-inner-right-icon-ic"
                            onClick={() => {
                                dispatch(setIsCartOpen(true))
                            }}>
                            <img alt="" src={cart} />
                            {restaurantDataState?.orderDetails?.Carts?.Items?.length > 0 && <div
                                className="MenuNavbarV4-inner-right-icon-ic-cart">{restaurantDataState?.orderDetails?.Carts?.Items?.length}</div>}
                        </div>
                        <div className="MenuNavbarV4-inner-right-icon-ic">
                            <img alt="" src={notification} />
                        </div>
                        <div className="MenuNavbarV4-inner-right-icon-ic-prof">
                            <img alt="" src={user} />
                        </div>
                    </div>
                </div>
            </div>
            {selectedOrderType === "" || (window.location.pathname.includes("/order") || window.location.pathname.includes("/account")) ? "" : selectedOrderType !== "table" &&
                <div className='MenuNavbarV4-mobile'>
                    <div className='MenuNavbarV4-mobile-cont'
                        style={{ backgroundColor: (selectedOrderType === "delivery" && addressDelivery?.City) || localStorage.getItem("schedule_order") ? "" : "transparent" }}>

                        {selectedOrderType === "delivery" && addressDelivery?.City &&
                            <div className='MenuNavbarV4-mobile-cont-item'
                                onClick={() => {
                                    setAddDeliveryLoc(true)
                                }}>
                                <img alt='' src={loc} className='MenuNavbarV4-mobile-cont-item-img' />
                                <div className='MenuNavbarV4-mobile-cont-item-text'>
                                    <div className='MenuNavbarV4-mobile-cont-item-text-hdr'>Delivering to</div>
                                    <div className='MenuNavbarV4-mobile-cont-item-text-sub'>{addressDelivery?.City}, UK</div>
                                </div></div>}
                        {(selectedOrderType === "delivery" && addressDelivery?.City) && localStorage.getItem("schedule_order") && <div className="MenuNavbarV4-mobile-cont-sep" />}
                        {localStorage.getItem("schedule_order") ?
                            <div className='MenuNavbarV4-mobile-cont-item'
                                onClick={() => {
                                    setIsStoreClosed(true)
                                }}>
                                <img alt='' src={clock} className='MenuNavbarV4-mobile-cont-item-img' />
                                <div className='MenuNavbarV4-mobile-cont-item-text'>
                                    <div className='MenuNavbarV4-mobile-cont-item-text-hdr'>{getFormatSchedule().date}</div>
                                    <div className='MenuNavbarV4-mobile-cont-item-text-sub'>{getFormatSchedule().time}</div>
                                </div>
                                <img alt="" src={arrow} className='MenuNavbarV4-mobile-cont-item-img2' />
                            </div> : ""}

                    </div>
                </div>}

        </div>
    )
}
export default Navbar